import type { InputProps } from "@mui/material";
import { InputAdornment } from "@mui/material";
import classNames from "classnames";
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { AppIconButton } from "../../../../../shared/components/AppIconButton";
import { AppInput } from "../../../../../shared/components/AppInput";
import { EyeIcon } from "../../../../../shared/icons/EyeIcon";
import { EyeInvisibleIcon } from "../../../../../shared/icons/EyeInvisibleIcon";
import { LockIcon } from "../../../../../shared/icons/LockIcon";
import styles from "../../styles.module.css";

interface Props extends InputProps {
  password: string;
  onChange: (value: ChangeEvent<HTMLInputElement>) => void;
  isPasswordVisible: boolean;
  onClick: () => void;
  className?: string;
}

export const PasswordInput = ({
  password,
  onChange,
  isPasswordVisible,
  onClick,
  className,
  ...rest
}: Props) => {
  const { t } = useTranslation();
  return (
    <AppInput
      value={password}
      onChange={onChange}
      type={isPasswordVisible ? "text" : "password"}
      startAdornment={
        <InputAdornment position="start">
          <LockIcon />
        </InputAdornment>
      }
      endAdornment={
        <InputAdornment position="end">
          <AppIconButton
            onClick={onClick}
            className={styles["eye-icon-button"]}
          >
            {isPasswordVisible ? (
              <EyeIcon className={styles["eye-icon"]} />
            ) : (
              <EyeInvisibleIcon className={styles["eye-icon"]} />
            )}
          </AppIconButton>
        </InputAdornment>
      }
      placeholder={t("login.password")}
      className={classNames(styles.input, className)}
      inputClassName={styles["inner-input"]}
    />
  );
};
